var map = {
	"./BuddhaAkshay/loader.json": [
		11004,
		4
	],
	"./JanBhavishya/loader.json": [
		20347,
		347
	],
	"./Suvarna/loader.json": [
		83495,
		495
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72701;
module.exports = webpackAsyncContext;